import ProductSizes from './ProductSizes';

export default ProductSizes;